import moment from 'moment';

export interface OfflineActivityTimerSession {
  orderUuid: string;
  activityUuid: string;
  timeManagementUuid?: string;
  dateStart: string; 
  activityName?: string | null;
  comment?: string | null;
  startedOnline: boolean;
  userSymbols?: string;
}

const STORAGE_KEY = 'offlineActivityTimer';

export const getActivityTimerSession = (): OfflineActivityTimerSession | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as OfflineActivityTimerSession;
  } catch (error) {
    console.error('❌ Error reading offline activity timer session:', error);
    return null;
  }
};

export const saveActivityTimerSession = (session: OfflineActivityTimerSession) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    console.log('💾 Saved offline activity timer session', session);
  } catch (error) {
    console.error('❌ Error saving offline activity timer session:', error);
  }
};

export const clearActivityTimerSession = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    console.log('🧹 Cleared offline activity timer session');
  } catch (error) {
    console.error('❌ Error clearing offline activity timer session:', error);
  }
};

export const getNowFormatted = () => {
  return moment().format('DD/MM/YYYY HH:mm:ss');
};
